module.exports = __webpack_public_path__ + "static/parfume_4k-3ccc4862112986068425449ab9b5c63c.webp";